import { __spreadArray } from "tslib";
import { useCallback, useState } from 'react';
export function useToggleIndices(multiple, initialIndices) {
    if (multiple === void 0) { multiple = false; }
    if (initialIndices === void 0) { initialIndices = []; }
    var _a = useState(initialIndices), openIndices = _a[0], setOpenIndices = _a[1];
    var toggle = useCallback(function (index) {
        return setOpenIndices(function (indices) {
            return indices.includes(index) ? indices.filter(function (m) { return m !== index; }) : multiple ? __spreadArray(__spreadArray([], indices, true), [index], false) : [index];
        });
    }, [multiple]);
    return [openIndices, toggle];
}
//# sourceMappingURL=useToggleIndices.js.map